<template>
	<div :class="['box--form', col, { error: isError, 'is-disabled': isDisabled }]">
		<label :for="inputId" :class="{ required: isRequired }" v-if="showLabel">{{ label }}</label>
		<div class="input-wrapper">
			<!-- O select encapsula as opções corretamente -->
			<select v-bind="{ 'data-qa': $attrs['data-qa'] }" :id="inputId" :name="inputId" :disabled="isDisabled" :value="modelValue"
				@change="$emit('update:modelValue', $event.target.value)">
				<option disabled selected value="">{{ placeholder }}</option>
				<slot></slot> <!-- As opções serão injetadas aqui -->
			</select>
		</div>
		<span v-show="isError" class="alertErro" v-bind="{ 'data-qa': errorDataQa }">
			<Icons name="exclamation" /> {{ messageError }}
		</span>
	</div>
</template>

<script>
import Icons from '@/components/Icons.vue';
export default {
	components: {
		Icons
	},
	computed: {
		errorDataQa() {
			const selector = this.$attrs['data-qa']
			return typeof selector === 'string' ? `${selector.replace(/-select$/, '')}-error` : undefined
		}
	},
	props: {
		modelValue: [String, Number],
		label: { type: String, required: true },
		inputId: { type: String, required: true },
		col: { type: String, default: "" },
		isRequired: { type: Boolean, default: false },
		isError: { type: Boolean, default: false },
		isDisabled: { type: Boolean, default: false },
		messageError: { type: String, default: "" },
		placeholder: { type: String, default: "Select an option" },
		showLabel: {
			type: Boolean,
			default: true
		}
	},
	emits: ["update:modelValue"],
};
</script>
